import type { RTDBEventValue } from '@/types/rtdb';

let audioElement: HTMLAudioElement | null = null;

function ensureAudio(): HTMLAudioElement {
  if (!audioElement) {
    audioElement = new Audio('/sounds/notify_2.mp3');
    audioElement.preload = 'auto';
  }
  return audioElement;
}

/**
 * Chime for a fired reminder. Unlike playAlertIfBackground this is NOT gated
 * on the tab being backgrounded — the whole point of a reminder is to
 * interrupt the agent who is working in the app.
 */
export function playReminderChime(): void {
  ensureAudio()
    .play()
    .catch(() => {
      // Autoplay blocked by browser — ignore
    });
}

export function playAlertIfBackground(event: RTDBEventValue): void {
  const isIncoming =
    (event.z?.isIncoming === true) ||
    (typeof event.b === 'string' && event.b.toLowerCase() === 'received');

  if (!isIncoming) return;

  if (document.hidden || !document.hasFocus()) {
    ensureAudio()
      .play()
      .catch(() => {
        // Autoplay blocked by browser — ignore
      });
  }
}
